// extracted by mini-css-extract-plugin
module.exports = {"LanguageToggle":"LanguageToggle___moWNs","ToggleText":"ToggleText___2atJh","Options":"Options___3OHjl","IsActive":"IsActive___3M9M0","loading":"loading___zblgd"};